__turbopack_context__.v({
  "notifyModal": "BottomBar-module__ooz1Pa__notifyModal",
  "price-block": "BottomBar-module__ooz1Pa__price-block",
  "root": "BottomBar-module__ooz1Pa__root",
  "shipping": "BottomBar-module__ooz1Pa__shipping",
  "subtitle-text-btn": "BottomBar-module__ooz1Pa__subtitle-text-btn",
  "tax-disclaimer": "BottomBar-module__ooz1Pa__tax-disclaimer",
  "total-price-single": "BottomBar-module__ooz1Pa__total-price-single",
});
